var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 15.5833 16.2917",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.08333C8.8912 7.08333 9.20833 7.40046 9.20833 7.79167C9.20833 8.18287 8.8912 8.5 8.5 8.5H4.95833C4.56713 8.5 4.25 8.18287 4.25 7.79167C4.25 7.40046 4.56713 7.08333 4.95833 7.08333H8.5Z",
    fill: "var(--fill-0, #29363D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.25C11.0162 4.25 11.3333 4.56713 11.3333 4.95833C11.3333 5.34953 11.0162 5.66667 10.625 5.66667H4.95833C4.56713 5.66667 4.25 5.34953 4.25 4.95833C4.25 4.56713 4.56713 4.25 4.95833 4.25H10.625Z",
    fill: "var(--fill-0, #29363D)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85417 0C12.5706 4.56365e-08 15.5833 3.01275 15.5833 6.72917C15.5833 10.4456 12.5706 13.4583 8.85417 13.4583H7.86222C7.82332 13.4585 7.79181 13.49 7.79167 13.5289V15.6719C7.79167 16.0142 7.51418 16.2917 7.17187 16.2917C4.87695 16.2917 2.99829 14.5097 2.84371 12.254C2.84297 12.2434 2.83973 12.2334 2.83472 12.2243L2.81396 12.2008C1.11074 10.9798 0 8.98468 0 6.72917C9.12726e-08 3.01275 3.01275 4.56337e-08 6.72917 0H8.85417ZM6.72917 1.41667C3.79515 1.41667 1.41667 3.79515 1.41667 6.72917C1.41667 8.50786 2.29056 10.0822 3.6392 11.049C4.00398 11.3105 4.22686 11.719 4.25692 12.1572C4.34233 13.4035 5.21165 14.4343 6.375 14.7636V13.5289C6.37515 12.7076 7.04092 12.0418 7.86222 12.0417H8.85417C11.7882 12.0417 14.1667 9.66318 14.1667 6.72917C14.1667 3.79515 11.7882 1.41667 8.85417 1.41667H6.72917Z",
    fill: "var(--fill-0, #29363D)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.e6794191837b16a36b475079de5b7f1d.svg";
export { ForwardRef as ReactComponent };